'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _dekuScrollUp = require('@viskan/deku-scroll-up');

var _dekuScrollUp2 = _interopRequireDefault(_dekuScrollUp);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var render = function render(_ref) {
	var props = _ref.props;
	var background = props.background,
	    cmsLoaded = props.cmsLoaded,
	    color = props.color,
	    duration = props.duration,
	    opacity = props.opacity,
	    paddingHorizontal = props.paddingHorizontal,
	    paddingVertical = props.paddingVertical,
	    placement = props.placement,
	    radius = props.radius,
	    show = props.show,
	    size = props.size,
	    styleClasses = props.styleClasses,
	    symbol = props.symbol,
	    top = props.top;

	var date = new Date();

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-ScrollToTop', 'CMS-ScrollToTop--' + placement] },
		!styleClasses.Scroll_To_Top && (0, _magicVirtualElement2.default)(
			'style',
			{ key: cmsLoaded && date.getTime() + '-style' },
			'\n\t\t\t\t\t.CMS-ScrollToTop .ScrollUpLegacyStyles {\n\t\t\t\t\t\tpadding: ' + paddingVertical + 'px ' + paddingHorizontal + 'px;\n\t\t\t\t\t\tfont-size: ' + size + ';\n\t\t\t\t\t\tcolor: ' + color + ';\n\t\t\t\t\t\tbackground: ' + background + ';\n\t\t\t\t\t\tborder-radius: ' + radius + '%;\n\t\t\t\t\t\topacity: ' + opacity / 100 + ';\n\t\t\t\t\t}\n\t\t\t\t'
		),
		(0, _magicVirtualElement2.default)(
			_dekuScrollUp2.default,
			{ key: cmsLoaded && date.getTime() + '-ScrollUp', styleClasses: styleClasses, duration: parseInt(duration, 10), show: parseInt(show, 10), top: parseInt(top, 10) },
			(0, _magicVirtualElement2.default)('div', { innerHTML: symbol })
		)
	), props);
}; /** @jsx dom */
exports.default = { render: render };